import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getActionAttributes", "getActionDisabled", "getActionIcon", "getActionLabel", "getActionOnClick", "getActionRef", "getActionTagName", "actions", "className"];
import { cnBem } from '@carnica/utils';
import React from 'react';
import { withRenderFlag } from '@beef/react';
import { CellGrid } from "../../Cell";
import styles from "./styles.pcss";
var cnStatusViewActions = cnBem('status-view-actions', styles);
var StatusViewActionsRender = function StatusViewActionsRender(_ref) {
  var getActionAttributes = _ref.getActionAttributes,
    getActionDisabled = _ref.getActionDisabled,
    getActionIcon = _ref.getActionIcon,
    getActionLabel = _ref.getActionLabel,
    getActionOnClick = _ref.getActionOnClick,
    getActionRef = _ref.getActionRef,
    getActionTagName = _ref.getActionTagName,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnStatusViewActions(null, [className])
  }, otherProps, {
    "data-t-id": "StatusView-StatusViewActions"
  }), actions.slice(0, 3).map(function (action, i) {
    var attributes = getActionAttributes(action) || {};
    return /*#__PURE__*/React.createElement(CellGrid, _extends({}, attributes, {
      className: cnStatusViewActions('action', [attributes.className]),
      disabled: getActionDisabled(action),
      icon: getActionIcon(action),
      key: cnStatusViewActions('item', {
        i: i
      }),
      onClick: getActionOnClick(action),
      ref: getActionRef(action),
      tagName: getActionTagName(action),
      title: getActionLabel(action)
    }));
  }));
};
export var StatusViewActions = withRenderFlag({
  shouldRenderFn: function shouldRenderFn(_ref2) {
    var actions = _ref2.actions;
    return !!(actions !== null && actions !== void 0 && actions.length);
  }
})(StatusViewActionsRender);